var config = require("app/config"),
    get    = require("object-path").get;

/**
 * Create casting configuration for Radiant Media Player from the
 * provided watching session.
 *
 * @param    {Object}  session  The watching session
 * @returns  {Object}  The casting setup
 */
module.exports = function(session) {
    var setup               = {};

    setup.airplay                 = true;
    setup.googleCast              = true;
    setup.googleCastReceiverAppId = config.googleCastReceiverAppId;
    setup.googleCastHeaders       = {
        "CloudFront-Policy":      get(session, "CloudFront-Policy", null),
        "CloudFront-Signature":   get(session, "CloudFront-Signature", null),
        "CloudFront-Key-Pair-Id": get(session, "CloudFront-Key-Pair-Id", null)
    };

    return setup;
};
